module.exports = __webpack_public_path__ + "lighthouse-logo.png";